module.exports = __webpack_public_path__ + "static/img/S.2d032b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hjzs/S.png
// module id = lh3y
// module chunks = 0